import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { Button } from '@sorare/core/src/atoms/buttons/Button';
import {
  Dropdown,
  DropdownOptionLabel,
} from '@sorare/core/src/atoms/dropdowns/Dropdown';
import { ChevronDownBold } from '@sorare/core/src/atoms/icons/ChevronDownBold';
import { NewScarcityIcon } from '@sorare/core/src/atoms/icons/ScarcityIcon';
import { scarcityMessages } from '@sorare/core/src/lib/scarcity';

const StyledDropdownOptionLabel = styled(DropdownOptionLabel)`
  align-items: center;
  svg,
  img {
    margin-right: var(--unit);
  }
`;

const StyledChevronDownBold = styled(ChevronDownBold)`
  transition: transform 0.3s;
  &.chevron-up {
    transform: rotate(180deg);
  }
`;

type Props<T extends Rarity> = {
  rarities: T[];
  selectedRarity: T;
  onChange: (rarity: T) => void;
};

export const SelectRarity = <T extends Rarity>({
  rarities,
  selectedRarity,
  onChange,
}: Props<T>) => {
  return (
    <Dropdown
      align="right"
      label={({ open, ...props }) => (
        <Button
          size="small"
          startIcon={<NewScarcityIcon rarity={selectedRarity} />}
          color="quaternary"
          endIcon={
            <StyledChevronDownBold className={open ? 'chevron-up' : ''} />
          }
          {...props}
        />
      )}
    >
      {({ closeDropdown }) =>
        rarities.map(r => (
          <StyledDropdownOptionLabel
            key={r}
            onClick={() => {
              onChange(r);
              closeDropdown();
            }}
          >
            <NewScarcityIcon rarity={r} />
            <FormattedMessage {...scarcityMessages[r]} />
          </StyledDropdownOptionLabel>
        ))
      }
    </Dropdown>
  );
};
